const alignViewer = document.getElementById('alignViewer');
const images = alignViewer.getElementsByTagName('img');
const slider = document.getElementById('imageSlider');
const playPauseButton = document.getElementById('playPauseButton');
let currentImage = 0;
let direction = 1; // 1 for forward, -1 for backward
let autoplayInterval;
let isAutoplaying = false;

// Function to update the image
function updateImage() {
    for (let i = 0; i < images.length; i++) {
        images[i].classList.remove('active');
    }
    images[currentImage].classList.add('active');
}

// Function to autoplay images back and forth
function autoplay() {
    currentImage += direction;
    if (currentImage >= images.length - 1 || currentImage <= 0) {
        direction *= -1; // Reverse direction
    }
    updateImage();
    slider.value = currentImage; // Update slider position
}

// Start autoplay
function startAutoplay() {
    if (!isAutoplaying) {
        autoplayInterval = setInterval(autoplay, 1000);
        isAutoplaying = true;
        playPauseButton.textContent = '⏸';
    }
}

// Stop autoplay
function stopAutoplay() {
    clearInterval(autoplayInterval);
    isAutoplaying = false;
    playPauseButton.textContent = '▶';
}

// IntersectionObserver to start autoplay when in viewport
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            startAutoplay();
        } else {
            stopAutoplay();
        }
    });
}, { threshold: 0.5 }); // Adjust threshold as needed

observer.observe(alignViewer);

// Event listeners to stop autoplay on mousedown or touchstart
alignViewer.addEventListener('mousedown', stopAutoplay);
alignViewer.addEventListener('touchstart', stopAutoplay);

// Event listeners to start autoplay on mouseup or touchend
alignViewer.addEventListener('mouseup', startAutoplay);
alignViewer.addEventListener('touchend', startAutoplay);

// Slider input event listener
slider.addEventListener('input', (e) => {
    currentImage = parseInt(e.target.value);
    updateImage();
});

// Play/Pause button event listener
playPauseButton.addEventListener('click', () => {
    if (isAutoplaying) {
        stopAutoplay();
    } else {
        startAutoplay();
    }
});